export function isCompatible(value: string): boolean {
  // Not a valid semantic version check, because it allows four numbers (e.g. 1.1.1.1). In contrast semver -> https://semver.org/
  return /\bv?(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)\.(?:0|[1-9]\d*)(?:-[\da-z-]+(?:\.[\da-z-]+)*)?(?:\+[\da-z-]+(?:\.[\da-z-]+)*)?\b/.test(
    value,
  );
}
